import * as Yup from 'yup';

export const hasDuplicateOptionText = (options) => {
  const seen = new Set();
  for (const option of options) {
    const text = option.optionText?.trim().toLowerCase();
    if (!text) return false; // Return false if empty or whitespace-only
    if (seen.has(text)) {
      return true;
    }
    seen.add(text);
  }
  return false;
};

export const scoreCardValidationSchema = Yup.object().shape({
  scoreCards: Yup.array().of(
    Yup.object().shape({
      question: Yup.string()
        .required('Question is required')
        .transform((value) => (value ? value.trim() : value)) // Trim the value before validation
        .test(
          'not-empty',
          'Question cannot be empty',
          (value) => value?.length > 0
        )
        .test('unique-question', 'Question already exists', function (value) {
          if (!value) return true;

          const { path, from } = this;
          const scoreCards = from[1].value.scoreCards;
          const currentIndex = parseInt(path.split('[')[1].split(']')[0]);

          // Check if the question exists in any previous questions
          for (let i = 0; i < scoreCards.length; i++) {
            if (
              i !== currentIndex &&
              scoreCards[i].question &&
              scoreCards[i].question.trim().toLowerCase() ===
                value.trim().toLowerCase()
            ) {
              return false;
            }
          }

          return true;
        }),
      type: Yup.string().required('Type is required'),
      options: Yup.array().when('type', {
        is: (type) => ['multiple_choice', 'checkbox'].includes(type),
        then: (schema) =>
          schema
            .min(2, 'At least two options are required')
            .of(
              Yup.object().shape({
                optionText: Yup.string()
                  .required('Option is required')
                  .transform((value) => (value ? value.trim() : value)) // Trim the value before validation
                  .test(
                    'not-empty',
                    'Option cannot be empty',
                    (value) => value?.length > 0
                  ),
              })
            )
            .test('unique-option', 'Option already exists', function (value) {
              if (!value) return true;

              const { path, from } = this;
              const scoreCards = from[1].value.scoreCards;
              const currentIndex = parseInt(path.split('[')[1].split(']')[0]);
              const currentOptions = scoreCards[currentIndex].options;
              // Return false to trigger error if duplicate is found
              return !hasDuplicateOptionText(currentOptions);
            }),
        otherwise: (schema) => schema.notRequired(),
      }),
    })
  ),
});
